import api from '../../configuration/api'

export const categories = {
  list: (data) => api.get('categories', data),
};
